export const transformData = (data) => {
  return {
    id: data?.id ?? '',
    name: data?.name ?? '',
    totalRecipients: data?.total_receipients ?? 0,
    failed: data?.failed ?? 0,
  };
};
